/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeRectHIcon32Regular = forwardRef('ShapeRectHIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 10.5A5.5 5.5 0 0 1 7.5 5h17a5.5 5.5 0 0 1 5.5 5.5v11a5.5 5.5 0 0 1-5.5 5.5h-17A5.5 5.5 0 0 1 2 21.5v-11ZM7.5 7A3.5 3.5 0 0 0 4 10.5v11A3.5 3.5 0 0 0 7.5 25h17a3.5 3.5 0 0 0 3.5-3.5v-11A3.5 3.5 0 0 0 24.5 7h-17Z" })));
});
